import createIcon from '../../createIcon';

/**
 * @component @name Payments
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTRWNkMxOSA0LjkgMTguMSA0IDE3IDRIM0MxLjkgNCAxIDQuOSAxIDZWMTRDMSAxNS4xIDEuOSAxNiAzIDE2SDE3QzE4LjEgMTYgMTkgMTUuMSAxOSAxNFpNMTAgMTNDOC4zNCAxMyA3IDExLjY2IDcgMTBDNyA4LjM0IDguMzQgNyAxMCA3QzExLjY2IDcgMTMgOC4zNCAxMyAxMEMxMyAxMS42NiAxMS42NiAxMyAxMCAxM1pNMjMgN1YxOEMyMyAxOS4xIDIyLjEgMjAgMjEgMjBINFYxOEgyMVY3SDIzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Payments = createIcon('Payments', [
  [
    'path',
    {
      d: 'M19 14V6C19 4.9 18.1 4 17 4H3C1.9 4 1 4.9 1 6V14C1 15.1 1.9 16 3 16H17C18.1 16 19 15.1 19 14ZM10 13C8.34 13 7 11.66 7 10C7 8.34 8.34 7 10 7C11.66 7 13 8.34 13 10C13 11.66 11.66 13 10 13ZM23 7V18C23 19.1 22.1 20 21 20H4V18H21V7H23Z',
      key: 'i582k7',
    },
  ],
]);

export default Payments;
